import React from 'react';
import PostForm from '../post-form';

const AddPost = () => {
  return <PostForm mode="create" />;
};

export default AddPost;
